<template>
    <v-container>
        <v-layout wrap>
            <v-flex xs12>
                <w-main-title
                        title="Miembros de la Institución"
                        :breadcrumbs="breadcrumbs"
                ></w-main-title>
            </v-flex>
        </v-layout>
        <v-layout wrap align-items justify-center>
            <v-flex xs12 text-xs-right pa-0>
              <div class="caption mr-2">
                Cuentas profesionales disponibles: <b>{{remainingMemberAccounts}}</b>
              </div>
            </v-flex>
            <v-flex xs12 text-xs-right pa-0>
                <v-btn fab small depressed @click="getMembers()" class="my-1"><v-icon>fa-sync</v-icon></v-btn>
                <v-btn outline color="secondary" @click="addUser" class="my-1">
                    Agregar miembro <v-icon right size="14">fas fa-user-plus</v-icon>
                </v-btn>
            </v-flex>
            <v-flex xs12 text-xs-center pt-2>
                <v-progress-circular color="primary" width="1" v-if="loading" indeterminate />
                <v-slide-y-transition>
                    <member-list
                        v-on:select="onMemberSelect"
                        v-on:detach="onMemberDetach"
                        v-show="!loading"
                        :items="members"/>
                </v-slide-y-transition>
            </v-flex>
        </v-layout>
        <member-form
            :disable-specialists="remainingMemberAccounts < 1"
            :me="isMe"
            v-on:success="onMemberSave"
            ref="memberForm"
            :user="selectedMember"
        />
    </v-container>
</template>
<script>

    import WMainTitle from '@/components/common/WMainTitle'
    import MemberList from '../../components/providers/panel/MemberList'
    import MemberForm from '../../components/providers/panel/MemberForm'

    import {mapState, mapMutations, mapGetters} from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'

    export default{
        components: {
            WMainTitle,
            MemberList,
            MemberForm
        },
        data(){
            return {
                loading: false,
                getMembersInterval: null,
                members: [],
                isMe: false,
                selectedMember: null,
                breadcrumbs: [
                    {
                        text: 'Miembros',
                        disabled: true,
                        to: ''
                    }
                ],
            }
        },
        mounted(){
          const vm = this
          vm.getMembers()
          vm.getMembersInterval = setInterval(function(){
            vm.getMembers(true);
          }, 30000)
        },
      beforeDestroy() {
        const vm = this
        clearInterval(vm.getMembersInterval)
        vm.getMembersInterval = null
      },
      methods: {
            ...mapMutations(['showSnackBar']),
            onMemberSave(members){
                this.members =members
            },
            addUser(){
                var vm = this
                vm.selectedMember = null
                vm.$refs.memberForm.show()
            },
            onMemberSelect(member, isMe){
                const vm = this
                vm.isMe = isMe
                vm.selectedMember = member
                vm.$refs.memberForm.show()
            },
            onMemberDetach(detached){
                var vm = this
                vm.members = vm.members.slice().filter(member => member.email !== detached)
            },
            async getMembers(silent = false){

                var vm = this
                if(!vm.currentProvider){
                    return
                }

                if(!silent) vm.loading = true
                var response = await ApiUtils.makeGet(`provider/${vm.currentProvider.id}/members`)
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando consultar miembros')
                    return
                }

                const json = await response.json()
                vm.members = json.result.members

            }
        },
        computed: {
          ...mapState(['currentProvider', 'currentBranchOffice']),
          ...mapGetters(['subscribedPlan', 'trialIsExpired']),
          remainingMemberAccounts(){
            const vm = this
            const specialistsCount = vm.members.filter(usr => usr.role_id === 3).length
            if(vm.trialIsExpired && !vm.subscribedPlan){
              return 1 - specialistsCount
            }
            if(!vm.subscribedPlan) return 0;
            return vm.subscribedPlan.max_specialists - specialistsCount
          }
        },
        watch:{
            currentBranchOffice(val){
                if(val){
                    this.getMembers()
                }
            }
        }
    }
</script>
